import { createSelector } from 'reselect';
import {
  getCurrencyFromParams,
  currencyName,
  currencyColor,
  currencyType,
  getReferralCryptoWallet,
  cryptoWallet
} from '../../../utilities/selectors';

const getIso = (state, props) =>
  state.global.currencies[props.location.state.iso];

export const makeGetCryptoWallet = () =>
  createSelector(getIso, getReferralCryptoWallet, cryptoWallet);

export const makeGetCurrencyName = () =>
  createSelector(getIso, getCurrencyFromParams, currencyName);

export const makeGetCurrencyColor = () =>
  createSelector(getIso, getCurrencyFromParams, currencyColor);

export const makeGetCurrencyType = () =>
  createSelector(getIso, getCurrencyFromParams, currencyType);
